import isEmpty from 'lodash/isEmpty';
import {v4 as uuid } from 'uuid';
import {
    defaultField,
    getOptins,
    getDeviceInfo,
    getCustomFields,
    getFullName,
    removeEmptyFields,
} from './captureFieldsAPI';

function captureFields () {

    const appStore = this.env.appStore;
    const schedulesStore = this.env.schedulesStore;
    const self = this;
    clearTimeout(this.captureTO);

    const subscribersFields = this.subscribersFields;
    const customValues = this.customValues;
    const optinValues = this.optinValues;

    function capture () {
        self.validateFields();
        self.validateRequired();
        // console.log('captureFields() capture: fieldErrors: ', self.fieldErrors);
        if (!isEmpty(self.fieldErrors)) {
            return;
        }

        const optins = getOptins(optinValues);
        const subscribersParams = {
            ...defaultField,
            ...subscribersFields,
            ...optins,
            location: appStore.location,
            ...getDeviceInfo(appStore.userAgent, appStore.flags),
            fingerprint: appStore.fingerprint,
            name: getFullName(subscribersFields.first_name, subscribersFields.last_name),
            icsFilename: appStore.widget.ics_filename,
            subscriptionWidgetId: appStore.widget.id,
            calendarIds: schedulesStore.getSelectedSchedules(),
        };
        
        subscribersParams.custom_fields = getCustomFields(customValues);
        self.subscribersParams = subscribersParams;
        // console.log('captureFields() Before Removal -> -> : ', self.subscribersParams);
        self.subscribersParams = removeEmptyFields(self.subscribersParams);
        console.log('captureFields() self.subscribersParams -> : ', self.subscribersParams);

        if (subscribersFields.parentConsentOn === 'no' && isEmpty(subscribersFields.parentEmail)) {
            self.isRequiredFilledIn = false;
            self.observed.isRequiredFilledIn = uuid();
        } else if (self.customParentConsentValue === 'no' && isEmpty(customValues.parentEmail)) {
            self.isRequiredFilledIn = false;
            self.observed.isRequiredFilledIn = uuid();
        }
    }
   
    this.captureTO = setTimeout(capture, 400);
   
}

export default captureFields;